import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Protected } from "@/components/Protected";
import StaffLayout from "@/components/StaffLayout";
import AdminLayout from "@/components/AdminLayout";
import Login from "@/pages/Login";
import StaffHome from "@/pages/staff/StaffHome";
import MyTasks from "@/pages/staff/MyTasks";
import TaskDetail from "@/pages/staff/TaskDetail";
import AddLead from "@/pages/staff/AddLead";
import Profile from "@/pages/staff/Profile";
import Dashboard from "@/pages/admin/Dashboard";
import LiveMap from "@/pages/admin/LiveMap";
import Attendance from "@/pages/admin/Attendance";
import Payroll from "@/pages/admin/Payroll";
import StaffDirectory from "@/pages/admin/StaffDirectory";
import Tasks from "@/pages/admin/Tasks";
import Leads from "@/pages/admin/Leads";
import Clients from "@/pages/admin/Clients";
import AttendanceLog from "@/pages/admin/AttendanceLog";
import Products from "@/pages/admin/Products";
import QuoteList from "@/pages/quotes/QuoteList";
import QuoteBuilder from "@/pages/quotes/QuoteBuilder";

const Home = () => {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "staff" ? "/app" : "/admin"} replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/app" element={<Protected><StaffLayout /></Protected>}>
            <Route index element={<StaffHome />} />
            <Route path="tasks" element={<MyTasks />} />
            <Route path="tasks/:id" element={<TaskDetail />} />
            <Route path="lead" element={<AddLead />} />
            <Route path="profile" element={<Profile />} />
            <Route path="quotes" element={<QuoteList base="/app/quotes" />} />
            <Route path="quotes/new" element={<QuoteBuilder />} />
            <Route path="quotes/:id" element={<QuoteBuilder />} />
          </Route>
          <Route path="/admin" element={<Protected roles={["hr", "director"]}><AdminLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="map" element={<LiveMap />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="attendance-log" element={<AttendanceLog />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="staff" element={<StaffDirectory />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="leads" element={<Leads />} />
            <Route path="clients" element={<Clients />} />
            <Route path="products" element={<Products />} />
            <Route path="quotations" element={<QuoteList base="/admin/quotations" admin />} />
            <Route path="quotations/new" element={<QuoteBuilder />} />
            <Route path="quotations/:id" element={<QuoteBuilder />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </AuthProvider>
  );
}

export default App;
